import React, { Component } from 'react';
import AspectRatioContainer from '../aspect-ratio-container/AspectRatioContainer'
import AlignmentContainer from '../alignment-container/AlignmentContainer'
import { bootstrapBreakpoints } from '../../utils/BootstrapBreakpoints'
import PubSub from 'pubsub-js';
import Constants from '../../Constants';



class FullWidthVideoBanner extends Component {

  constructor(props) {
    super(props);

    this.state = {
      breakpoint: bootstrapBreakpoints.getActiveBreakpoints()
    };
  }

  componentWillUnmount() {
    if (this.state.bootstrapBreakpointChangedSubscription) {
      PubSub.unsubscribe(this.bootstrapBreakpointChangedSubscription);
    }
  }

  componentDidMount() {
    this.setState({
      bootstrapBreakpointChangedSubscription: PubSub.subscribe(Constants.eventKeys.bootstrapBreakpointChanged, (message, data) => this.handleBreakpointChanged(data))
    });
  }

  handleBreakpointChanged = (breakpoint) => {
    this.setState({
      breakpoint: breakpoint
    });
  };


  render() {
    let bannerImage = true;
    let banner;

    if (this.state.breakpoint.xl || this.state.breakpoint.lg || this.state.breakpoint.md) {
      bannerImage = false;
    }


    if(!bannerImage){
      banner= (
        <div>
          <img className="position-absolute w-100 d-none d-md-block" src={this.props.image.path} alt={this.props.image.description}/>
          <video className="position-absolute w-100 h-100 d-none d-md-block"  src={this.props.video.path} type="video/mp4" autoPlay muted loop={this.props.video.loop}/>
        </div>
      );
    } else {
      banner= (
         <img className="img-fluid position-absolute w-100" src={this.props.mobileImage.path} alt={this.props.mobileImage.description}/>
      );
    }
      
      return (
      <AspectRatioContainer  className={'eir-fullwidth-video-banner'} xs="10-16" md="16-9" >
        {banner}
        <AlignmentContainer 
          title={this.props.title}
          text={this.props.text}
          fluid={true}
          theme={this.props.theme}
          cta={this.props.cta}
          countdownTimer={this.props.countdownTimer} 
          alignment={this.props.alignment}
          useH1={this.props.useH1}
        />
      </AspectRatioContainer>
      
    );
  }
}

export default FullWidthVideoBanner;
